import styled, { useTheme } from "styled-components";

const SvgContainer = styled.div`
  width: fit-content;
  height: 90px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  flex-shrink: 0; /* Evita que se comprima */

  @media (max-width: 768px) {
    height: 75px;
    gap: 8px;
  }

  @media (max-width: 480px) {
    height: 60px;
    gap: 6px;
  }
`;

const PorcentajeTexto = styled.div`
  font-size: 2.5rem;
  font-weight: bold;
  color: ${({ $porcentaje, theme }) => 
    $porcentaje >= 90 
      ? theme.porcentaje1 || "#28a745"
      : $porcentaje >= 70 
      ? theme.porcentaje2 || "#ffc107"
      : $porcentaje >= 50 
      ? theme.porcentaje3 || "#fd7e14"
      : theme.porcentaje4 || "#dc3545"
  };
  white-space: nowrap;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

const StyledSvg = styled.svg`
  width: 60px;
  height: 100%;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 50px;
  }

  @media (max-width: 480px) {
    width: 40px;
  }
`;

const PacienteFigura = ({ porcentaje = 100, genero = "M" }) => {
  const theme = useTheme();
  
  // Generar ID único para evitar conflictos si hay múltiples instancias
  const gradienteId = `gradienteFigura-${genero}-${Math.random().toString(36).substr(2, 9)}`;
  
  // Colores con fallbacks
  const colorCompleto = theme.porcentaje1 || "#28a745";
  const colorIncompleto = theme.porcentaje4 || "#dc3545";
  
  // Validar porcentaje
  const porcentajeValido = Math.min(Math.max(porcentaje, 0), 100);

  return (
    <SvgContainer>
      <PorcentajeTexto $porcentaje={porcentajeValido}>
        {porcentajeValido}%
      </PorcentajeTexto>
      
      <StyledSvg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={genero === "M" ? "0 0 32 40" : "0 0 350 475"}
        aria-label={`Figura de paciente ${genero === "M" ? "masculino" : "femenino"} con ${porcentajeValido}% de progreso`}
      >
        <defs>
          <linearGradient id={gradienteId} x1="0" y1="0" x2="0" y2="1">
            <stop offset={`${porcentajeValido}%`} stopColor={colorCompleto} />
            <stop offset={`${porcentajeValido}%`} stopColor={colorIncompleto} />
          </linearGradient>
        </defs>

        {genero === "M" ? (
          // Figura masculina
          <path
            d="M23.188.75a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zM12.063 8.594a1.5 1.5 0 0 0-.813 2.562l4.875 5.125a1.5 1.5 0 0 0 2.156.032l.657-.657.75 9.094v15a1.5 1.5 0 1 0 3 0v-15h1v15a1.5 1.5 0 1 0 3 0v-15l.75-9.094.718.719v7.375a1.5 1.5 0 1 0 3 0v-8a1.5 1.5 0 0 0-.406-1.063l-3.688-3.718a4.494 4.494 0 0 0-3.875-2.219c-1.617 0-3.019.844-3.812 2.125l-2.156 2.219-3.813-4a1.5 1.5 0 0 0-1.187-.5 1.5 1.5 0 0 0-.156 0z"
            fill={`url(#${gradienteId})`}
          />
        ) : (
          // Figura femenina
          <path
            d="M190.4 148.6 161 252.9c-6.3 22.8 20.7 31.7 27.3 10.3l26.3-96.2h7.4l-45.2 169H219v127c0 23 32 23 32 0V336h10v127c0 23 31 23 31 0V336h43.4l-46.2-169h8.4l26.3 96.2c6.5 21.9 33.3 12.5 27.3-10.2l-29.4-104.4c-4-11.8-18.2-32.6-42-33.6h-47.3c-24.6 1-38.7 21.6-42.1 33.6zM292.6 69.2c0-20.6-16.4-37.3-36.6-37.3-20.2 0-36.6 16.7-36.6 37.3 0 20.6 16.4 37.3 36.6 37.3 20.2 0 36.6-16.7 36.6-37.3z"
            fill={`url(#${gradienteId})`}
          />
        )}
      </StyledSvg>
    </SvgContainer>
  );
};

export default PacienteFigura;
